import { Text } from '@wix/design-system';
import React from 'react';
import { BiModalTypes } from '../../bi/types';
import { isClassicEditorHost } from '../../utils/get-editor-host';
import { showErrorModal } from './show-error-modal';
export const getGenerateAllErrorModalProps = (t, editorHost) => ({
  content: isClassicEditorHost(editorHost) ? t('accessibility-wizard.alt-text.generating-all-error-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.alt-text.generating-all-error-modal.content')),
  primaryButtonText: t('accessibility-wizard.alt-text.generating-all-error-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.alt-text.generating-all-error-modal.secondary-button'),
  theme: 'destructive',
  title: t('accessibility-wizard.alt-text.generating-all-error-modal.title')
});
export const showGenerateAllErrorModal = async _ref => {
  let {
    handleTryAgain,
    handleCancel,
    a11yWizardAdapter,
    biLogger,
    t,
    editorHost
  } = _ref;
  await showErrorModal({
    ...getGenerateAllErrorModalProps(t, editorHost),
    a11yWizardAdapter,
    editorHost,
    primaryButtonOnClick: () => handleTryAgain(),
    secondaryButtonOnClick: handleCancel
  });
  biLogger.modalView({
    modalType: BiModalTypes.GenerateWithAiError
  });
};
//# sourceMappingURL=show-generate-all-error-modal.js.map